import { connect } from "react-redux";

import { gtag } from "ga-gtag";

import constants from "../../assets/constants";
import * as OmniDataAPI from "../../data/omniDataAPI";
import { createNewUserRelationship } from "../../data/omniDataModel";
import * as AdminSession from "../../state/redux/adminSession";
import * as AssessmentSession from "../../state/redux/assessmentSession";
import * as OnboardingSession from "../../state/redux/onboardingSession";
import * as PartnerSession from "../../state/redux/partnerSession";
import * as PatientSession from "../../state/redux/patientSession";
import * as ProviderSession from "../../state/redux/providerSession";
import { deepCopyObject } from "../../utils/helpers";
import { getIdByRelationshipType } from "../../utils/helpers";
import AssessmentDefaultDisplay from "./assessmentDefaultDisplay";
import { hydrateNewAssessment } from "./hydrationUtilities";
import { scoreCompletedAssessment, scrapeSubjectData } from "./scrapingUtilities";

const WizardPerformAssessment = props => {
  const { originalAssessmentODM, subjectODM, proctorODM, userODM, onClose } = props;

  const processCompletedAssessmentODM = completedAssessmentODM => {
    //this class should be responsible for scraping the assessments and then updating the subjectODM

    let updatedSubjectODM = deepCopyObject(subjectODM);
    let updatedProctorODM = deepCopyObject(proctorODM);
    if (originalAssessmentODM.omniData.validated) {
      try {
        for (let index = 0; index < completedAssessmentODM.omniData.questions.length; ++index) {
          updatedSubjectODM = scrapeSubjectData(
            completedAssessmentODM.omniData.questions[index],
            updatedSubjectODM,
          );
        }
        updatedSubjectODM = scoreCompletedAssessment(completedAssessmentODM, updatedSubjectODM);
        let now = new Date();
        updatedSubjectODM.omniData.patientData.lastScrape = now.toISOString();
      } catch (error) {
        console.log(error);
      }

      if (!userODM) {
        props.setOnboardingProctorODMRequest(updatedProctorODM);
        props.setOnboardingSubjectODMRequest(updatedSubjectODM);
        props.setAssesssmentODMRequest(completedAssessmentODM);
        //close this!
        onClose();
      } else {
        try {
          //Save all Data
          if (updatedSubjectODM._id == null) {
            let newRelationship = createNewUserRelationship(
              updatedProctorODM,
              constants.omniRelationshipTypes.patientPartner,
            );

            updatedSubjectODM.omniRelationships.relatedData.push(newRelationship);

            OmniDataAPI.createPatient(updatedSubjectODM).then(response => {
              let assessmentRelationships =
                completedAssessmentODM.omniRelationships.relatedData.slice();

              //Subject, response is a patientODM, FYI
              let assessmentRelationship = createNewUserRelationship(
                response,
                constants.omniRelationshipTypes.assessmentSubject,
              );
              assessmentRelationships.push(assessmentRelationship);
              props.providerReflectUpdatedPatientODMRequest(response);
              props.partnerReflectUpdatedPatientODMRequest(response);
              props.adminReflectUpdatedPatientODMRequest(response);

              //update userData if a proxy patient was used
              let proxyPatientID = getIdByRelationshipType(
                response.omniRelationships.relatedData,
                constants.omniRelationshipTypes.proxyPatient,
              );

              if (
                proxyPatientID === userODM._id &&
                userODM.omniData.hasOwnProperty("partnerData")
              ) {
                //update and save.

                //this should maybe be a WHOLE user data at some point
                //these will have been created from the initial user
                userODM.omniData.birthdate = response.omniData.birthdate;
                userODM.omniData.gender = response.omniData.gender;
                userODM.omniData.race = response.omniData.race;
                userODM.omniData.ethnicity = response.omniData.ethnicity;
                userODM.omniData.email = response.omniData.email;
                userODM.omniData.mobilePhone = response.omniData.mobilePhone;
                userODM.omniData.address.postalCode = response.omniData.address.postalCode;

                props.updatePartnerRequest(userODM);
              }

              //Proctor
              assessmentRelationship = createNewUserRelationship(
                updatedProctorODM,
                constants.omniRelationshipTypes.assessmentProctor,
              );
              assessmentRelationships.push(assessmentRelationship);

              //set relationships
              completedAssessmentODM.omniRelationships.relatedData = assessmentRelationships;

              props.updateAssessmentRequest(completedAssessmentODM);
            });
          } else {
            //we should do an update, they could have added Demo info
            if (updatedSubjectODM.omniData.hasOwnProperty("patientData")) {
              props.updatePatientRequest(updatedSubjectODM);
            }

            //update userData if a proxy patient was used
            let proxyPatientID = getIdByRelationshipType(
              updatedSubjectODM.omniRelationships.relatedData,
              constants.omniRelationshipTypes.proxyPatient,
            );

            if (proxyPatientID === userODM._id && userODM.omniData.hasOwnProperty("partnerData")) {
              //update and save.

              //this should maybe be a WHOLE user data at some point
              //these will have been created from the initial user
              userODM.omniData.birthdate = updatedSubjectODM.omniData.birthdate;
              userODM.omniData.gender = updatedSubjectODM.omniData.gender;
              userODM.omniData.race = updatedSubjectODM.omniData.race;
              userODM.omniData.ethnicity = updatedSubjectODM.omniData.ethnicity;
              userODM.omniData.email = updatedSubjectODM.omniData.email;
              userODM.omniData.mobilePhone = updatedSubjectODM.omniData.mobilePhone;
              userODM.omniData.address.postalCode = updatedSubjectODM.omniData.address.postalCode;

              props.updatePartnerRequest(userODM);
            }

            //Subject, response is a patientODM, FYI
            let assessmentRelationship = createNewUserRelationship(
              updatedSubjectODM,
              constants.omniRelationshipTypes.assessmentSubject,
            );
            completedAssessmentODM.omniRelationships.relatedData.push(assessmentRelationship);

            //Proctor
            assessmentRelationship = createNewUserRelationship(
              updatedProctorODM,
              constants.omniRelationshipTypes.assessmentProctor,
            );
            completedAssessmentODM.omniRelationships.relatedData.push(assessmentRelationship);

            props.updateAssessmentRequest(completedAssessmentODM);
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    //these three things key transition to the next step
    props.setUpdatedSubjectODM(updatedSubjectODM);
    props.setUpdatedProctorODM(updatedProctorODM);
    props.setCompletedAssessmentODM(completedAssessmentODM);
  };

  gtag("event", "omni_assessment_start_click", {
    omni_assessment_type: originalAssessmentODM.omniData.omniType,
  });

  return (
    <AssessmentDefaultDisplay
      //Send it in fully hydrated!
      originalAssessmentODM={hydrateNewAssessment(originalAssessmentODM, subjectODM)}
      subjectODM={subjectODM}
      proctorODM={proctorODM}
      onAcceptHandler={processCompletedAssessmentODM}
    />
  );
};

const mapStateToProps = state => ({
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  updateProviderRequest: ProviderSession.updateProviderRequest,

  providerReflectUpdatedPatientODMRequest: ProviderSession.reflectUpdatedPatientODMRequest,
  partnerReflectUpdatedPatientODMRequest: PartnerSession.reflectUpdatedPatientODMRequest,
  adminReflectUpdatedPatientODMRequest: AdminSession.reflectUpdatedPatientODMRequest,

  updatePatientRequest: PatientSession.updatePatientRequest,
  updatePartnerRequest: PartnerSession.updatePartnerRequest,

  updateAssessmentRequest: AssessmentSession.updateAssessmentRequest,

  setAssesssmentODMRequest: OnboardingSession.setAssesssmentODMRequest,
  setOnboardingSubjectODMRequest: OnboardingSession.setOnboardingSubjectODMRequest,
  setOnboardingProctorODMRequest: OnboardingSession.setOnboardingProctorODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardPerformAssessment);
